import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CommercialRepairServices from "./sections/CommercialRepairServices";
import INostriServizi from "./sections/INostriServizi";
import WhyChooseUs from "./sections/WhyChooseUs";
import MapContactDetails from "./sections/MapContactDetails";
import Testimonials from "./sections/Testimonials";
import GetInTouch from "./sections/GetInTouch";
import Gallery from "./sections/Gallery";
import SubsurfaceInvestigation from "./sections/SubsurfaceInvestigation";
import FieldTesting from "./sections/FieldTesting";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <CommercialRepairServices />
      <INostriServizi />
      <SubsurfaceInvestigation />
      <FieldTesting />
      <WhyChooseUs />
      <MapContactDetails />
      <Testimonials />
      <GetInTouch />
      <Gallery />
      <Footer />
    </div>;
}